import { Icon, Text, VStack } from "@chakra-ui/react";
import Nav from "../components/nav/Nav";
import Container from "../components/Container";
import { CheckCircle } from "@phosphor-icons/react";
import Footer from "../components/Footer";

export default function UserActivationSuccess() {
  return (
    <VStack gap={0} minH={"100vh"}>
      <Nav />

      <Container my={"auto"}>
        <VStack px={10} py={10} pb={20}>
          <Icon
            as={CheckCircle}
            fontSize={150}
            weight={"thin"}
            color={"p.500"}
          />
          <Text
            fontSize={32}
            fontWeight={600}
            color={"p.500"}
            textAlign={"center"}
          >
            Selamat, akun anda telah diaktivasi
          </Text>
          <Text fontSize={20} textAlign={"center"}>
            Silahkan sign in
          </Text>
        </VStack>
      </Container>

      <Footer />
    </VStack>
  );
}
